import { createQueryHook } from '~/shared/providers/api';

export const useCustomerInvitationByTokenQuery = createQueryHook(
  'crm.customerInvitationByToken',
  (params: { token: string }) => ({
    customerInvitationByToken: {
      __args: {
        token: params.token,
      },
      id: true,
      account: {
        id: true,
        name: true,
      },
      email: true,
      invitationStatus: true,
      expiresAt: true,
    },
  }),
);
